// extracted by mini-css-extract-plugin
module.exports = {"content":"_5b10bb2305--content--nIMCd","time":"_5b10bb2305--time--Xki7O"};